import { useMutation } from '@tanstack/react-query';
import { authClients } from '../http/userApi'; // путь может отличаться
import { PostAuthClientsResponse } from '../http/userApi';
import { setCookie } from '../utils/cookies';
// Определяем интерфейсы
interface AuthClientData {
  phone: string;
  password: string;
}

export const usePostAuthClientsMutation = () => {
  return useMutation<PostAuthClientsResponse, Error, AuthClientData>({
    mutationFn: async ({ phone, password }) => {
      const response = await authClients(phone, password);
      return response.data;
    },
    onError: (error) => {
      console.error('Ошибка авторизации:', error);
    },
    onSuccess: (data) => {
      setCookie('user_token', data.data.user_token);
      const userTokensArrString = JSON.stringify(data.data.user_tokens);
      setCookie('user_tokens', userTokensArrString);
    },
  });
};
